/* Приказните рисунки на сайта — звездички, луна, облачета, сърчица, бебешки
   стъпчици и вълната между секциите. Вградени SVG: рисуват се веднага, не
   тежат и се оцветяват с currentColor или с fill от пропса. Всички са само
   украса, затова са скрити за екранните четци. */

const svgProps = {
  "aria-hidden": "true",
  focusable: "false",
};

export const Sparkle = ({ size = 24, color = "var(--sa-butter-500)", className = "", style }) => (
  <svg {...svgProps} className={className} style={style} width={size} height={size} viewBox="0 0 24 24">
    <path
      d="M12 1.5c.6 4.6 2.2 7.6 4.3 8.9 1.6 1 3.7 1.4 6.2 1.6-2.5.2-4.6.6-6.2 1.6-2.1 1.3-3.7 4.3-4.3 8.9-.6-4.6-2.2-7.6-4.3-8.9-1.6-1-3.7-1.4-6.2-1.6 2.5-.2 4.6-.6 6.2-1.6 2.1-1.3 3.7-4.3 4.3-8.9Z"
      fill={color}
    />
  </svg>
);

export const Moon = ({ size = 48, color = "var(--sa-butter-300)", className = "", style }) => (
  <svg {...svgProps} className={className} style={style} width={size} height={size} viewBox="0 0 48 48">
    <path d="M31.5 4.5A20 20 0 1 0 43.5 36 16 16 0 0 1 31.5 4.5Z" fill={color} />
    <circle cx="17" cy="22" r="2.2" fill="rgba(0,0,0,0.07)" />
    <circle cx="23" cy="32" r="3" fill="rgba(0,0,0,0.06)" />
  </svg>
);

export const Cloud = ({ width = 120, color = "#fff", className = "", style }) => (
  <svg {...svgProps} className={className} style={style} width={width} height={width * 0.5} viewBox="0 0 120 60">
    <path
      d="M24 54c-11 0-20-7-20-16s8-15 18-15c2-11 11-19 23-19 10 0 18 5 22 13 3-2 7-3 11-3 11 0 20 8 20 18 8 1 14 7 14 14 0 5-4 8-9 8H24Z"
      fill={color}
    />
  </svg>
);

export const Heart = ({ size = 22, color = "var(--sa-rose-400)", className = "", style }) => (
  <svg {...svgProps} className={className} style={style} width={size} height={size} viewBox="0 0 24 24">
    <path
      d="M12 21s-7.5-4.6-9.6-9.4C.9 8.2 2.7 4.5 6.3 4c2.2-.3 4 .8 5.7 2.9C13.7 4.8 15.5 3.7 17.7 4c3.6.5 5.4 4.2 3.9 7.6C19.5 16.4 12 21 12 21Z"
      fill={color}
    />
  </svg>
);

/* Две бебешки стъпчици — знакът на прощъпулника */
export const Footprints = ({ size = 40, color = "var(--sa-rose-300)", className = "", style }) => (
  <svg {...svgProps} className={className} style={style} width={size} height={size} viewBox="0 0 48 48">
    <g fill={color}>
      <ellipse cx="14" cy="30" rx="6" ry="9" transform="rotate(-12 14 30)" />
      <circle cx="9" cy="17.5" r="2" />
      <circle cx="12.5" cy="16" r="1.8" />
      <circle cx="16" cy="16.2" r="1.6" />
      <circle cx="19" cy="17.4" r="1.4" />
      <ellipse cx="33" cy="22" rx="6" ry="9" transform="rotate(12 33 22)" />
      <circle cx="28.5" cy="9.4" r="1.4" />
      <circle cx="31.6" cy="8.2" r="1.6" />
      <circle cx="35.2" cy="8.2" r="1.8" />
      <circle cx="38.8" cy="9.8" r="2" />
    </g>
  </svg>
);

/* Вълна: `edge="bottom"` стои в дъното на секция и се оцветява с цвета на
   СЛЕДВАЩАТА секция; `edge="top"` — в горния край, с цвета на предишната. */
export const Wave = ({ color = "var(--sa-paper)", edge = "bottom", className = "" }) => (
  <svg
    {...svgProps}
    className={`sa-wave ${className}`}
    viewBox="0 0 1440 80"
    preserveAspectRatio="none"
    style={{ color, transform: edge === "top" ? "scaleY(-1)" : undefined }}
  >
    <path
      d="M0 44c120-26 240-34 360-18s240 42 360 36 240-40 360-44 240 22 360 30v32H0Z"
      fill="currentColor"
    />
  </svg>
);

/* Мека поляна в дъното на хероя: два пастелни хълма един зад друг, върху
   които „стъпват“ рамките със снимките — страницата става сцена от книжка,
   а не само цветен фон. */
export const Hills = ({ className = "" }) => (
  <svg
    {...svgProps}
    className={`sa-hills ${className}`}
    viewBox="0 0 1440 220"
    preserveAspectRatio="none"
  >
    <path
      d="M0 96c170-44 300-52 440-24s250 74 430 58 320-78 430-62 140 30 140 30V220H0Z"
      fill="var(--sa-mint-100)"
    />
    <path
      d="M0 146c190-36 310-16 440 12s260 46 430 22 330-52 430-36 140 26 140 26V220H0Z"
      fill="var(--sa-lav-100)"
    />
  </svg>
);

/* Разпръснати звездички за тъмен фон (нощното небе във футъра) */
export const StarField = ({ count = 18, seed = 7 }) => {
  // Детерминистични позиции — еднакви при всяко рендериране и при prerender
  let s = seed;
  const rand = () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
  return (
    <div className="sa-starfield" aria-hidden="true">
      {Array.from({ length: count }, (_, i) => {
        const size = 6 + Math.round(rand() * 12);
        return (
          <Sparkle
            key={i}
            size={size}
            className="sa-doodle sa-twinkle"
            color={i % 4 === 0 ? "var(--sa-rose-200)" : "var(--sa-butter-300)"}
            style={{
              left: `${Math.round(rand() * 96)}%`,
              top: `${Math.round(rand() * 88)}%`,
              animationDelay: `${(rand() * 3).toFixed(2)}s`,
              opacity: 0.85,
            }}
          />
        );
      })}
    </div>
  );
};
